import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserProfile } from 'src/app/models/userProfile';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userId;
  user: UserProfile = new UserProfile();
  userMode = "On";
  library;
  constructor(private activateRout: ActivatedRoute, private http: HttpClient) { }

  ngOnInit() {
    this.activateRout.params.subscribe(
      params => this.userId = params.userId
    )

    this.user.name = "Werner von Siemens"
  }

  changeUserMode(userMode){
    this.userMode = userMode === 'On' ? 'Off' : 'On';
  }

}
